export const priceCatalog = {
  'priceCatalog.previousPublication': 'Предыдущая публикация',
  'priceCatalog.currentPublication': 'Текущая публикация',
  'priceCatalog.name': 'Название',
  'priceCatalog.state': 'Состояние',
  'priceCatalog.active': 'Действует',
  'priceCatalog.archived': 'В архиве',
  'priceCatalog.open': 'Открыть: {name}',
  'priceCatalog.empty': 'Публикаций нет',
  'priceCatalog.emptyDetail': 'Коммерческие условия ещё не опубликованы.',
  'priceCatalog.publication': 'Публикация',
  'priceCatalog.taxPublication': 'Публикация налога',
  'priceCatalog.newPublication': 'Изменить для публикации',
  'priceCatalog.publish': 'Опубликовать условия',
  'priceCatalog.archive': 'Архивировать справочник',
  'priceCatalog.saving': 'Сохранение…',
  'priceCatalog.from': 'Действует с',
  'priceCatalog.until': 'До, не включая эту дату',
  'priceCatalog.addInterval': 'Добавить период',
  'priceCatalog.adjustments': 'Корректировки цены',
  'priceCatalog.addAdjustment': 'Добавить корректировку',
  'priceCatalog.key': 'Код правила',
  'priceCatalog.order': 'Порядок применения',
  'priceCatalog.adjustmentKind': 'Корректировка',
  'priceCatalog.fixedDiscount': 'Фиксированная скидка',
  'priceCatalog.percentDiscount': 'Процентная скидка',
  'priceCatalog.fixedSurcharge': 'Фиксированная надбавка',
  'priceCatalog.percentSurcharge': 'Процентная надбавка',
  'priceCatalog.percent': 'Процент',
  'priceCatalog.amount': 'Сумма',
  'priceCatalog.cap': 'Предельная корректировка, необязательно',
  'priceCatalog.basis': 'База расчёта',
  'priceCatalog.originalGross': 'Исходная стоимость с налогом',
  'priceCatalog.runningGross': 'Стоимость после предыдущих корректировок',
  'priceCatalog.stacking': 'Совмещение',
  'priceCatalog.stack': 'Совмещается с другими корректировками',
  'priceCatalog.exclusive': 'Исключительная корректировка',
  'priceCatalog.reason': 'Основание',
  'priceCatalog.reasonRequired': 'Укажите основание длиной не менее трёх символов.',
  'priceCatalog.remove': 'Удалить из черновика',
  'priceCatalog.rateKind': 'Тип ставки',
  'priceCatalog.percentRate': 'Процент',
  'priceCatalog.fixedRate': 'Фиксированный сбор',
  'priceCatalog.fixedUnitAmount': 'Сбор за единицу услуги',
  'priceCatalog.addRate': 'Добавить ставку',
  'priceCatalog.priceTaxMode': 'Налог и цена услуги',
  'priceCatalog.additional': 'Начисляется сверх цены',
  'priceCatalog.rateUnavailable': 'Выбранная ставка не действует на эту дату. Явно назначьте действующую ставку.',
  'priceCatalog.taxSchedule': 'Ставки налога',
  'priceCatalog.treatment': 'Налогообложение',
  'priceCatalog.included': 'Включён в полную цену',
  'priceCatalog.zero': 'Нулевая ставка',
  'priceCatalog.exempt': 'Не облагается',
  'priceCatalog.rate': 'Ставка, проценты',
  'priceCatalog.addComponent': 'Добавить компонент налога',
  'priceCatalog.unsaved': 'Неопубликованные коммерческие условия',
  'priceCatalog.readOnly': 'Текущие права или состояние справочника не допускают изменений.',
  'priceCatalog.loadFailed': 'Не удалось загрузить справочник.',
  'priceCatalog.failed': 'Не удалось сохранить публикацию. Черновик сохранён.',
  'priceCatalog.invalid': 'Условия отклонены. Проверьте даты, источники, суммы и порядок правил.',
  'priceCatalog.changed': 'Справочник или выбранный источник изменился. Перечитайте данные перед публикацией.',
  'priceCatalog.profileMissing': 'Для публикации цен требуется финансовый профиль.',
  'priceCatalog.currencyChanged': 'Валюта черновика отличается от текущего профиля клиники. Прежние суммы нельзя переносить.',
  'priceCatalog.sourceUnavailable': 'Необходимая услуга, филиал или налоговый источник недоступны.',
  'priceCatalog.incomplete': 'Заполните название и периоды перед публикацией.',
  'priceCatalog.reload': 'Перечитать сохранённые условия',
  'priceCatalog.reloadFailed': 'Не удалось перечитать данные. Черновик сохранён.',
  'priceCatalog.reloaded': 'Сохранённые условия загружены. Проверьте их перед публикацией.',
} as const
